export const rules = {
  required: (v) => !!v || "This field is required",
  zeroRequired: (v) => v !== "" || "This field is required",
  email: (v) => {
    if (!v) return true;
    return (
      (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v) &&
        !/\.{2,}/.test(v)) ||
      "Enter a valid email address"
    );
  },
  password: (v) =>
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/.test(v) ||
    "Enter a valid password",
  float: (v) => !v || /^\d+(\.\d+)?$/.test(v) || "Enter a valid decimal number",
  number: (v) =>
    !v || (v >= 0 && /^-?\d*\.?\d+$|^-?$/.test(v)) || "Enter a valid number",
  reqNumber: (v, param) =>
    (v >= 0 && /^-?\d*\.?\d+$|^-?$/.test(v)) || `Enter a valid ${param}`,
  lt: (v, max) => v <= max || `Value must be less than or equal to ${max}`,
  gt: (v, min) => v >= min || `Value must be greater than or equal to ${min}`,
  trimWord: (v, param) => {
    return (!!v?.length && !!v?.trim().length) || `Enter a valid ${param}`;
  },
  mobile: (v) => {
    if (!v) return true;
    return /^\d{10}$/.test(v) || "Enter a valid 10-digit mobile number";
  },
  mobileLength: (v) => v?.length === 10 || "Enter a 10 digit mobile number",
  applicationNumber: (v) =>
    !v || v.length === 15 || "Enter a valid application number",
  usnNumber: (v) => 
    !v || (v.length >= 11 && /^-?\d*\.?\d+$|^-?$/.test(v))  || "Enter a valid USN",
  postalcode: (v) =>
    !v || (/^\d+$/.test(v) && v > 99999 && v <= 999999) || "Enter a valid code",
  alphabet: (v) => /^[A-Za-z ]+$/.test(v) || `Enter a valid name`,
  year: (v) => v >= new Date().getFullYear() || `year should be greater or equal to current year`,
  code: (v) => v?.length === 3 || "Enter a valid code",
  yearValidation: (v) => !v || v.length === 4 || `Enter a valid year`,
  arrayMinOne: (v) => (v && v.length >= 1) || 'Please select at least one option',
  week: (v) => {
    const currentYear = new Date().getFullYear();
    const totalWeeks = getISOWeeksInYear(currentYear);

    return (
      (v >= 1 && v <= totalWeeks) || `Enter a valid week (1-${totalWeeks})`
    );
  },
  url: (v) => {
    if (!v) return true;
    return (
      /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/.test(
        v
      ) || "Enter a valid url"
    );
  },
  minInstallments: (v) => {
    if (!v) return true;
    return v > 1 || `Installments should be greater than ${v}`;
  },
  getMax(max) {
    return (v) => {
      if (!v) return true;
      return (
        (v <= max && v > 0) || `Enter a value less than or equal to ${max}`
      );
    };
  },
  nonZero: (v) => {
    if (!v) return true;
    return v > 0 || `Enter a value greater than 0`;
  },
  courseFeeGreater(form) {
    return (v) => {
      const fee = parseFloat(v);
      const annual = parseFloat(form.annual_upfront);
      const full = parseFloat(form.full_upfront);

      if (isNaN(fee)) return "Enter a valid Course Fee";

      if ((!isNaN(annual) && fee < annual) || (!isNaN(full) && fee < full)) {
        return "Course Fee must be greater than or equal to Annual and Full Upfront";
      }

      return true;
    };
  },
  full_annual_upfront(form, name) {
    return (v) => {
      const fee = parseFloat(v);
      const term_fee = parseFloat(form.term_fee);

      if (isNaN(fee)) return `Enter a valid ${name}`;

      if (!isNaN(term_fee) && fee !== 0 && fee < term_fee) {
        return `${name} must be greater than term fee`;
      }

      return true;
    };
  },
  abcNumber: (v) => {
    if (!v) return true; // Pass if empty (optional)
    return /^\d{11,12}$/.test(v) || "Enter a valid ABC ID";
  },
  panNumber: (v) => {
    if (!v) return true; // Pass if empty (optional)
    return (
      /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) ||
      "Enter a valid PAN number (AAAAA1234A)"
    );
  },
  onlyString: (v) => /^[A-Za-z\s]+$/.test(v) || "This field should be valid",
  passportNumberRule: (v) => {
    if (!v) return true;
    return (
      /^[A-Z][0-9]{7}$/.test(v) ||
      "Invalid passport number format (e.g., A1234567)"
    );
  },
  aadhaarNumber: (v) =>
    /^\d{12}$/.test(v) || "Enter a valid 12 digit Aadhaar number",

  percentage: (v) => !v || (v >= 0 && v <= 100) || "Enter a valid percentage",
  gstLessThanFee: (fee) => (v) =>
    Number(v) <= Number(fee) || "GST % must be less than or equal to Fee %",

  acceptZero: (v) => {
    if (v === 0) return true;
    if (!v) return "This field is required";
    return (!isNaN(v) && v > 0) || "Enter a valid number";
  },
  stringLength: (v, length) =>
    !v || v.length <= length || `should be ${length} character(s)`,
  batchCode: (v) =>
    !v || /^\d{4}-\d+$/.test(v) || "Batch code must be in format YYYY-N (e.g. 2023-1)",
};

function getISOWeeksInYear(year) {
  const lastDay = new Date(year, 11, 31);
  const lastThursday = new Date(
    lastDay.setDate(lastDay.getDate() - ((lastDay.getDay() + 3) % 7))
  );

  return Math.ceil((lastThursday - new Date(year, 0, 4)) / (7 * 86400000)) + 1;
}
